// src/permissions/roles.js
// 권한 역할 상수/계층/헬퍼 (JS)

export const ROLES = {
  SUPERUSER: 'superuser',
  TENANT_ADMIN: 'tenant_admin',
  MANAGER: 'manager',
  STAFF: 'staff',
  GUEST: 'guest',
};

// 상위가 하위를 포함하는 계층
export const ROLE_RANK = {
  [ROLES.GUEST]: 0,
  [ROLES.STAFF]: 1,
  [ROLES.MANAGER]: 2,
  [ROLES.TENANT_ADMIN]: 3,
  [ROLES.SUPERUSER]: 4,
};

// 스코프(권한이 미치는 범위)
export const SCOPES = {
  ALL: 'all', // 모든 tenant/warehouse
  TENANT: 'tenant', // 선택된 tenant 범위
  WAREHOUSE: 'warehouse', // 선택된 warehouse 범위
  NONE: 'none',
};

// 사람 친화 라벨 (UI 표시용)
export const ROLE_LABELS = {
  [ROLES.SUPERUSER]: 'Super User',
  [ROLES.TENANT_ADMIN]: 'Admin',
  [ROLES.MANAGER]: 'Manager',
  [ROLES.STAFF]: 'Staff',
  [ROLES.GUEST]: 'Guest',
};

/**
 * 최소 역할 이상인지 비교
 * @param {string} role 현재 역할
 * @param {string} min 최소 요구 역할
 */
export const isAtLeast = (role, min) =>
  (ROLE_RANK[role] ?? -1) >= (ROLE_RANK[min] ?? 999);

/**
 * Administration 메뉴 노출 여부
 * - superuser / tenant_admin / manager: 노출
 * - staff / guest: 비노출
 */
export const canSeeAdministrationByRole = role =>
  role === ROLES.SUPERUSER ||
  role === ROLES.TENANT_ADMIN ||
  role === ROLES.MANAGER;

/**
 * 상단 Tenant 드롭다운 노출 규칙
 * - 슈퍼유저는 항상 노출
 * - 일반 유저는 보유 tenant 권한 개수가 2개 이상일 때만 노출
 * @param {string} role 현재 역할
 * @param {number} tenantCount 보유 테넌트 수
 */
export const shouldShowTenantDropdown = (role, tenantCount) => {
  if (role === ROLES.SUPERUSER) return true;
  return Number(tenantCount) >= 2;
};
